/**
 * ChatGradientWrapper — Fundo padronizado para caixas de chat com IA.
 * Cores do escritório: vermelho, branco e dourado em gradiente.
 * Especificação: mais branco, vermelho e dourado mais leves (docs/IA-FERRUGINI.md).
 */
import { ReactNode } from "react";

export interface ChatGradientWrapperProps {
  children: ReactNode;
  className?: string;
  /** Se true, aplica o gradiente na área do chat (scroll). Se false, na tela inteira. */
  areaOnly?: boolean;
}

export function ChatGradientWrapper({ children, className = "", areaOnly = false }: ChatGradientWrapperProps) {
  const gradientClass = "bg-gradient-to-br from-red-100/50 via-[#f9f6f0] to-amber-50/70";
  if (areaOnly) {
    return (
      <div
        className={`flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg ${gradientClass} ${className}`}
      >
        {children}
      </div>
    );
  }
  return (
    <div className={`min-h-full ${gradientClass} ${className}`}>
      {children}
    </div>
  );
}

export default ChatGradientWrapper;
